import { render, staticRenderFns } from "./CusPaymentsEditAdmin.vue?vue&type=template&id=2be38ca2&scoped=true"
import script from "./CusPaymentsEditAdmin.vue?vue&type=script&lang=js"
export * from "./CusPaymentsEditAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be38ca2",
  null
  
)

export default component.exports